<template>
  <f-n-j-select ref="select" :value="valueTitle" :clearable="clearable" @clear="clearHandle" filterable :disabled="disabled"  :filter-method="handleSearch" @visible-change="visibleChange">

    <div class="tree-select">
          <el-tree
            default-expand-all
            id="tree-option"
            ref="selectTree"
            :accordion="accordion"
            :data="options"
            :props="props"
            :node-key="props.value"
            :default-expanded-keys="defaultExpandedKey"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick">
          </el-tree>
    </div>


  </f-n-j-select>
</template>

<script>
    import FNJSelect from "@/components/TreeSelect/FNJSelect";
    export default {
        name: "el-tree-select",
        components: {FNJSelect},
        props:{
            disabled:{
                 type: Boolean,
                    default(){
                        return false;
                    } 
            },
            // 配置项
            props:{
                type: Object,
                default: {
                    value:'id',             // ID字段名
                    label: 'title',         // 显示名称
                    children: 'children'    // 子级字段名
                }
            },

            // 选项列表数据(树形结构的对象数组)
            options:{ type: Array, default: [] },

            // 初始值
            value:{ type: Number, default: null },
            filterMethod:{ type: Function, default: null },

            // 可清空选项
            clearable:{ type:Boolean, default: true },

            // 自动收起
            accordion:{ type:Boolean, default: false }
        },
        data() {
            return {
                valueId: null,
                valueTitle:'',
                defaultExpandedKey:[]
            }
        },
        mounted(){
            this.valueId = this.value,    // 初始值
                this.initHandle()
        },
        methods: {
            filterNode(value, data,node) {
                if (!value) return true;
                // return data.operatorName.indexOf(value) !== -1;
                return this.chooseNode(value, data,node)
            },
            // 过滤父节点，子节点：如果输入的参数是父节点且能匹配，则返回该节点以及其下的所有子节点
            chooseNode(value,data,node){
                if(data.operatorName.indexOf(value) !== -1){
                    return true
                }
                const level = node.level;
                // 如果只有一级，就不用效验了
                if(level===1){
                    return false;
                }
                // console.log(node)
                // 先取当前父节点
                let parentData = node.parent
                // 遍历当前节点的父节点
                let index = 0;
                while(index < level-1){
                    // 如果匹配到直接返回
                    if(parentData.data.operatorName.indexOf(value) !== -1){
                        return true  //判断上级是否存在value，存在显示子节点，不存在，不显示子节点
                    }
                    // 否则再往上一层做匹配
                    parentData = parentData.parent;
                    index++
                }
                // 没匹配到返回false
                return false;

            },
            visibleChange(){
                this.$refs.selectTree.filter("");
               // this.$emit("filter-method","")
            },
            handleSearch(data){
                this.$refs.selectTree.filter(data);
               // this.$emit("filter-method",data)


            },
            findItemName(list,id){
                for (let i = 0; i < list.length; i++) {
                   if(list[i][this.props.value]==id){
                       return  list[i][this.props.label]
                   }
                   if( list[i][this.props.children]){
                    let find=    this.findItemName(list[i][this.props.children],id)  ;
                    if(find){
                        return  find;
                    }
                   }
                }
                return undefined;
            },

            // 初始化值
            initHandle(){
              this.$nextTick(()=>{
                  this.$refs.selectTree.setCurrentKey(this.valueId)       // 设置默认选中
                  if(this.valueId){
                      this.defaultExpandedKey = [this.valueId];     // 设置默认展开
                      this.valueTitle=this.findItemName(this.options,this.valueId);
                  }else{
                      this.valueTitle="";
                  }


              })
            },

            // 切换选项
            handleNodeClick(node){
                this.valueTitle = node[this.props.label]
                this.valueId = node[this.props.value]
                this.$emit('getValue',this.valueId)
                this.$refs.select.blur();
            },
            // 清除选中
            clearHandle(){
                this.valueTitle = ''
                this.valueId = null
                this.defaultExpandedKey = []
                this.clearSelected()

                this.$emit('getValue',null)
            },
            // 清空选中样式
            clearSelected(){
                let allNode = document.querySelectorAll('#tree-option .el-tree-node')
                allNode.forEach((element)=>element.classList.remove('is-current'))
            }
        },
        watch: {
            options:{
                immediate:true,
                handler(value){
                    this.initHandle()
                }
            },
                value:{
                    immediate:true,
                    handler(value){

                        if (value) {
                            this.valueId = value;
                        } else {
                            this.valueId =null ;
                        }

                        this.initHandle()
                    }


                }

        },
    }
</script>

<style lang="scss">
  .tree-select{
    position: relative;
    z-index: 3000;
  .el-tree-node__content{
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
  }
  }
</style>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/TreeSelect/index.vue